import React from 'react'
import { ViewerLoader } from '../../viewer'
import { getVulnerabilityPolicyActionFromLocation } from '../../route/current-route'
import { BaseAssessRulesLoader } from '../../assess-rules/base-assess-rules-loader'
import { I18nConsumer } from '../../i18n-provider'
import { CreateVulnerabilityPolicyMutation } from './create-policy-mutation'
import { VulnerabilityPolicyCreateForm } from './create-form'
import { normalizeAction } from '../index'
import { OrganizationFeature } from '../../organization-feature/use-organization-feature'

export function VulnerabilityPolicyWrappedAddForm() {
  return (
    <ViewerLoader>
      {({ viewer, loading }) => {
        const actionString = getVulnerabilityPolicyActionFromLocation()

        return (
          !loading &&
          !!viewer && (
            <BaseAssessRulesLoader
              organizationID={viewer.currentOrganization.id}
            >
              {({ baseAssessRules }) => {
                return (
                  // useOrganizationFeature hook is not allowed here
                  <OrganizationFeature
                    organizationUuid={viewer.currentOrganization.id}
                    featureId="vulnerability-auto-verification"
                  >
                    {({
                      isLoading: loadingVulnAutoVerificationFlag,
                      enabled: vulnAutoVerificationEnabled
                    }) => {
                      return (
                        !loadingVulnAutoVerificationFlag && (
                          <div>
                            {Array.isArray(baseAssessRules) && actionString && (
                              <I18nConsumer>
                                {({ intl }) => (
                                  <CreateVulnerabilityPolicyMutation>
                                    {(createVulnerabilityPolicy) => (
                                      <VulnerabilityPolicyCreateForm
                                        action={normalizeAction(actionString)}
                                        intl={intl}
                                        organizationID={
                                          viewer.currentOrganization.id
                                        }
                                        baseAssessRules={baseAssessRules}
                                        createVulnerabilityPolicy={
                                          createVulnerabilityPolicy
                                        }
                                        vulnAutoVerificationEnabled={
                                          !!vulnAutoVerificationEnabled
                                        }
                                      />
                                    )}
                                  </CreateVulnerabilityPolicyMutation>
                                )}
                              </I18nConsumer>
                            )}
                          </div>
                        )
                      )
                    }}
                  </OrganizationFeature>
                )
              }}
            </BaseAssessRulesLoader>
          )
        )
      }}
    </ViewerLoader>
  )
}
